import script from "./DebuggingComponent.vue?vue&type=script&lang=js"
export * from "./DebuggingComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__